<button class="sidebar-toggle" (click)="isOpen = !isOpen" aria-label="Toggle navigation">
  <i class="zmdi zmdi-menu"></i>
</button>

<div class="sidebar-backdrop" [class.is-visible]="isOpen" (click)="isOpen = false"></div>

<nav id="sidebar" [class.is-open]="isOpen">
  <button class="sidebar-close" (click)="isOpen = false" aria-label="Close navigation">
    <i class="zmdi zmdi-close"></i>
  </button>
  <ul class="list-unstyled components">
    <li routerLinkActive="active">
      <a routerLink="dashboard" (click)="isOpen = false"
        ><i class="zmdi zmdi-home"></i>
        <div class="hidden-xs">Project Dashboard</div></a
      >
    </li>
    <li routerLinkActive="active">
      <a routerLink="model-compare" (click)="isOpen = false"
        ><i class="zmdi zmdi-compare"></i>
        <div class="hidden-xs">Model Compare</div></a
      >
    </li>
    <li routerLinkActive="active">
      <a routerLink="parameter-view" (click)="isOpen = false"
        ><i class="zmdi zmdi-filter-list"></i>
        <div class="hidden-xs">Parameter View</div></a
      >
    </li>
    <li routerLinkActive="active">
      <a routerLink="env-vars" (click)="isOpen = false"
        ><i class="zmdi zmdi-settings"></i>
        <div class="hidden-xs">Environment Variables</div></a
      >
    </li>
    <li routerLinkActive="active">
      <a routerLink="job-groups" (click)="isOpen = false"
        ><i class="zmdi zmdi-device-hub"></i>
        <div class="hidden-xs">Job Groups</div></a
      >
    </li>
    <li routerLinkActive="active">
      <a routerLink="data-table" (click)="isOpen = false"
        ><i class="zmdi zmdi-grid"></i>
        <div class="hidden-xs">Data Table</div></a
      >
    </li>
    <li routerLinkActive="active">
      <a routerLink="model-table" (click)="isOpen = false"
        ><i class="zmdi zmdi-shape"></i>
        <div class="hidden-xs">Model Table</div></a
      >
    </li>
    <li routerLinkActive="active">
      <a routerLink="flowchart" (click)="isOpen = false"
        ><i class="zmdi zmdi-chart"></i>
        <div class="hidden-xs">Model Flowchart</div></a
      >
    </li>
    <li routerLinkActive="active">
      <a routerLink="flowchart2" (click)="isOpen = false"
        ><i class="zmdi zmdi-chart"></i>
        <div class="hidden-xs">Model Flowchart 2</div></a
      >
    </li>
    <li routerLinkActive="active">
      <a routerLink="table" (click)="isOpen = false"
        ><i class="zmdi zmdi-storage"></i>
        <div class="hidden-xs">Storage Table</div></a
      >
    </li>
    <li routerLinkActive="active">
      <a routerLink="trace-fits-plotting" (click)="isOpen = false">
        <img
          src="/assets/icons/chart.png"
          style="height: 20px; object-fit: contain"
        />
        <div class="hidden-xs">Trace fits plotting</div></a
      >
    </li>
    <li routerLinkActive="active">
      <a routerLink="image-panel" (click)="isOpen = false"
        ><i class="zmdi zmdi-download"></i>
        <div class="hidden-xs">Image Download</div></a
      >
    </li>
  </ul>
</nav>
